var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"export"},[_c('h3',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t("export_for_exams")))]),_c('v-btn',{staticClass:"ml-2 transform-none",attrs:{"loading":_vm.isExport,"color":"accent"},on:{"click":_vm.onExport}},[_vm._v(" "+_vm._s(_vm.$t("Export to excel"))+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }